import { deleteField } from "firebase/firestore";

export function deleteUndefined(obj: object, isUpdate?: boolean) {
	const keys = Object.keys(obj) as Array<keyof typeof obj>;

	keys.forEach((key) => {
		if (obj[key] && typeof obj[key] === "object") {
			deleteUndefined(obj[key], isUpdate);
		} else if (obj[key] === undefined) {
			if (isUpdate) {
				(obj as any)[key] = deleteField();
			} else {
				delete obj[key];
			}
		}
	});

	return obj;
}
